import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[swipeleft], [swiperight]',
  standalone: false
})
export class SwipeDirective {
  @Output() swipeleft = new EventEmitter<void>();
  @Output() swiperight = new EventEmitter<void>();

  private startX: number | null = null;
  private startY: number | null = null;

  @HostListener('pointerdown', ['$event'])
  onPointerDown(event: PointerEvent): void {
    if (event.isPrimary) {
      this.startX = event.clientX;
      this.startY = event.clientY;
    }
  }

  @HostListener('pointerup', ['$event'])
  onPointerUp(event: PointerEvent): void {
    if (this.startX === null || this.startY === null || !event.isPrimary) {
      return;
    }

    const deltaX = event.clientX - this.startX;
    const deltaY = event.clientY - this.startY;
    this.reset();

    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (deltaX < 0) {
      this.swipeleft.emit();
    } else {
      this.swiperight.emit();
    }
  }

  @HostListener('pointercancel')
  reset(): void {
    this.startX = null;
    this.startY = null;
  }
}
